// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.dammlemonMug',
  title: 'hardCoded.title.dammlemonMug',
  slug: titleToSlug('hardCoded.title.dammlemonMug'),
  catalog: {
    title: 'hardCoded.catalog.title.dammlemonMug',
    catalogMedia,
    price: numberToCurrency('15'),
    color: '#419736'
  }
}
